import { useTheme } from '@cthings.co/styled-components';
import { useMediaType } from '@cthings.co/styles-utils';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@cthings.co/styled-components';
import { selectLanguageStrings } from '../../../../../../../../app/state/user';
import { CardType, DashboardCard } from '../../../../../../../../components/dashboardCard/DashboardCard';
import { media } from '@cthings.co/styles-utils';

import { colorFetchFDS as colorFetch } from '@cthings.co/styles-utils';
import { StatusOfCard } from '../../../../../../../../types/statusOfCards';
import { InfoCard } from '../../../../../../../../components/infoCard/InfoCard';

const GlobalRow = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const CardRow = styled.div`
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  ${media.desktop} {
    display: grid;
    grid-template-columns: repeat(2, 1fr) !important;
    grid-gap: 20px !important;
  }
  ${media.phone} {
    grid-template-columns: 1fr !important;
    grid-gap: 16px !important;
  }
`;

type StyledCardProps = {
  statusOfValue: StatusOfCard;
};

const StyledCard = styled(DashboardCard)<StyledCardProps>`
  & > div > div {
    & > span {
      color: ${({ statusOfValue, theme }) =>
        statusOfValue === StatusOfCard.CRITICAL
          ? colorFetch('red2')({ theme })
          : statusOfValue === StatusOfCard.WARNING
          ? colorFetch('orange2')({ theme })
          : statusOfValue === StatusOfCard.NORMAL
          ? colorFetch('black1')({ theme })
          : colorFetch('black1')({ theme })};
    }
    & > svg > path {
      stroke: ${({ statusOfValue, theme }) =>
        statusOfValue === StatusOfCard.CRITICAL
          ? colorFetch('red2')({ theme })
          : statusOfValue === StatusOfCard.WARNING
          ? colorFetch('orange2')({ theme })
          : statusOfValue === StatusOfCard.NORMAL
          ? colorFetch('primary')({ theme })
          : colorFetch('primary')({ theme })};
    }
  }
  ${media.desktop} {
    width: 100%;
    margin: 0;
  }
` as any; // @TODO fix type

const Space = styled.div`
  flex: 1;
  ${media.desktop} {
    order: -1;
  }
  ${media.phone} {
    display: none;
  }
`;

export const Cards = ({
  waterLevel,
  temp,
  statusOfWater,
  statusOfTemperature,
  infoCardData,
}: {
  waterLevel: any;
  temp: any;
  statusOfWater: any;
  statusOfTemperature: any;
  infoCardData?: any;
}) => {
  const theme = useTheme();

  const { desktop } = useMediaType();

  const languageStrings = useSelector(selectLanguageStrings);

  const { heading, issues } = infoCardData ? infoCardData : { heading: '', issues: '' };

  const countOfWater =
    waterLevel && !isNaN(waterLevel.measurement) ? `${waterLevel.measurement} ${waterLevel.unit}` : 'N/A';

  const countOfTemperature = temp && !isNaN(temp?.measurement) ? `${temp.measurement} ${temp.unit}` : 'N/A';

  return (
    <GlobalRow>
      <CardRow>
        <StyledCard
          placeholderProps={{
            keyword: 'ManholeDetailsCard',
            style: desktop ? { margin: '0', width: '100%' } : { margin: '0 20px 0 0' },
          }}
          theme={theme}
          languageStrings={languageStrings}
          title={waterLevel?.tile_name || languageStrings.insightDetailsRealTimeCardsWater}
          type={CardType.WATER_LEVEL}
          count={countOfWater}
          statusOfValue={statusOfWater}
        />
        <StyledCard
          placeholderProps={{
            keyword: 'ManholeDetailsCard',
            style: desktop ? { width: '100%' } : {},
          }}
          Card={theme}
          languageStrings={languageStrings}
          title={temp?.tile_name || languageStrings.insightDetailsRealTimeCardsTemperature}
          type={CardType.TEMPERATURE}
          count={countOfTemperature}
          statusOfValue={statusOfTemperature}
        />
        {infoCardData && (
          <>
            <Space />
            <InfoCard title={heading} data={issues} />
          </>
        )}
      </CardRow>
    </GlobalRow>
  );
};
